import { usePagination, useSortBy } from 'react-instantsearch';

import { FilterInDropdown } from '@sorare/core/src/atoms/dropdowns/FilterInDropdown';
import { RadioGroup } from '@sorare/core/src/atoms/inputs/RadioGroup';
import {
  AlgoliaCardIndexesName,
  PrintablePlayerSortName,
} from '@sorare/core/src/contexts/config';
import { useI18nSortByItems } from '@sorare/core/src/hooks/search/useI18nSortByItems';
import { useMarketplaceLifecycle } from '@sorare/core/src/hooks/useMarketplaceLifecycle';

interface Props {
  indexes: (AlgoliaCardIndexesName | PrintablePlayerSortName)[];
}

const SortCards = ({ indexes }: Props) => {
  const { refine: setPage } = usePagination();

  const { updateSort } = useMarketplaceLifecycle();

  const items = useI18nSortByItems(indexes);

  const { refine, currentRefinement } = useSortBy({ items });
  const selectedSort = items.find(i => i.value === currentRefinement);

  return (
    <FilterInDropdown buttonLabel={selectedSort?.label}>
      {({ closeDropdown }) => (
        <RadioGroup
          options={items}
          value={selectedSort?.value}
          name="draft-sort-type"
          onChange={(value: string) => {
            const selected = items.find(i => i.value === value);
            if (selected) {
              setPage(0);
              refine(selected.value);
              updateSort(selected.index);
              setTimeout(() => closeDropdown(), 100);
            }
          }}
        />
      )}
    </FilterInDropdown>
  );
};

export default SortCards;
